import _ from "lodash";
import { useEffect } from "react";
import { Form } from "react-bootstrap";
import toNumberFormat from "../../../../../function/toNumberFormat";
import usePackage from "../../../../../hooks/usePackage";
import useSharedData from "../../../../../hooks/useSharedData";
import style from "./FormShipmentInfo.module.css";

function FormShipmentInfo({ detail, setDetail, rowsData }) {
  const { calculatePackagingPrice, isFetching } = usePackage();
  const { isAgent } = useSharedData();

  useEffect(() => {
    setDetail(cur => {
      let totalCollectiveWeight = 0;
      let totalGrossWeight = 0;
      let totalWeightPayable = 0;
      let totalCost = 0;
      let totalPackaging = 0;
      let totalSpecialService = 0;

      rowsData.forEach(item => {
        if (item.weight) {
          totalCollectiveWeight += parseFloat(item.weight);
        }

        if (item.mass) {
          totalGrossWeight += parseFloat(item.mass);
        }

        if (item.cost) {
          totalCost += item.cost;
        }

        if (item.needPackaging) {
          totalPackaging += calculatePackagingPrice({
            type: item.packaging,
            width: item.width,
            length: item.length,
            height: item.height,
          });
        }

        if (item.serviceInPlace) {
          totalSpecialService += item.serviceInPlace;
        }
      });

      totalGrossWeight = Math.round(totalGrossWeight * 100) / 100;
      if (totalGrossWeight >= totalCollectiveWeight) {
        totalWeightPayable = Math.ceil(totalGrossWeight * 2) / 2;
      } else {
        totalWeightPayable = Math.ceil(totalCollectiveWeight * 2) / 2;
      }

      return {
        ...cur,
        totalNumber: rowsData.length,
        totalCollectiveWeight,
        totalGrossWeight,
        totalWeightPayable,
        totalCost,
        totalPrint: rowsData.length * 38000,
        totalPackaging,
        totalSpecialService,
      };
    });
  }, [rowsData, isFetching]);

  return (
    <section className={style.grid}>
      <div>
        <Form.Label>مجموع خدمات در محل (ريال)</Form.Label>
        <Form.Control
          name="totalNumber"
          value={detail.totalSpecialService.toLocaleString()}
          readOnly={true}
        />
      </div>
      <div>
        <Form.Label>مجموع تعداد پارت ها</Form.Label>
        <Form.Control
          name="totalNumber"
          value={detail.totalNumber}
          readOnly={true}
        />
      </div>
      <div>
        <Form.Label>مجموع وزن ناخالص</Form.Label>
        <Form.Control
          name="totalCollectiveWeight"
          value={_.round(detail.totalCollectiveWeight, 3)}
          readOnly={true}
        />
      </div>
      <div>
        <Form.Label>مجموع وزن حجمی</Form.Label>
        <Form.Control
          name="totalGrossWeight"
          value={detail.totalGrossWeight}
          readOnly={true}
        />
      </div>
      <div>
        <Form.Label>مجموع وزن قابل پرداخت</Form.Label>
        <Form.Control
          name="totalWeightPayable"
          value={detail.totalWeightPayable}
          readOnly={true}
        />
      </div>
      <div>
        <Form.Label>مجموع ارزش کالا(ريال)</Form.Label>
        <Form.Control
          name="totalCost"
          value={detail.totalCost?.toLocaleString()}
          readOnly={true}
        />
      </div>

      {isAgent && (
        <div>
          <Form.Label>مجموع هزینه پرینت مرسولات(ريال)</Form.Label>
          <Form.Control
            name="totalPrint"
            value={toNumberFormat(detail.totalPrint)}
            readOnly={true}
          />
        </div>
      )}

      <div>
        <Form.Label>مجموع هزینه بسته بندی(ريال)</Form.Label>
        <Form.Control
          name="totalPackaging"
          value={toNumberFormat(detail.totalPackaging)}
          readOnly={true}
        />
      </div>
    </section>
  );
}

export default FormShipmentInfo;
